export interface ContentConfig {
  content: {
    providerSchedulingPrefix: string;
    greetingMessage: {
      greeting: string;
      subtitle: string;
      disclaimer: string;
      learnMoreText: string;
      learnMoreAccessibilityLabel: string;
    };
    banner: {
      title: string;
      closeAriaLabel: string;
      infoAriaLabel: string;
      endChatDialog: {
        title: string;
        message: string;
        confirmButton: string;
        cancelButton: string;
        confirmAriaLabel: string;
        cancelAriaLabel: string;
      };
    };
    footer: {
      inputPlaceholder: string;
      inputAriaLabel: string;
      sendButtonAriaLabel: string;
      disclaimer: string;
    };
    promptOptions: Array<{
      identifier: string;
      title: string;
    }>;
    appointmentBookingForm: {
      title: string;
      submitButtonTitle: string;
      cancelButtonTitle: string;
      fields: Array<{
        fieldName: string;
        label: string;
        type: string;
        placeholder?: string;
        validations: Array<{
          regEx: string;
          message: string;
        }>;
      }>;
    };
    errors: {
      network: {
        title: string;
        message: string;
        retryButton: string;
      };
      session: {
        title: string;
        message: string;
        refreshButton: string;
      };
      generic: {
        title: string;
        message: string;
        retryButton: string;
        supportButton: string;
      };
      consent: {
        title: string;
        message: string;
        consentButton: string;
      };
      notFound: {
        title: string;
        message: string;
        homeButton: string;
      };
    };
  };
  featureFlags: {
    showTimestamps: boolean;
    showWelcomeBanner: boolean;
    bannerInfoButton: {
      enabled: boolean;
      visible: boolean;
    };
  };
}

interface FetchContentConfigOptions {
  baseUrl?: string;
}

const DEFAULT_BASE_URL = '/secure/api';

export const fetchContentConfig = async ({
  baseUrl = DEFAULT_BASE_URL,
}: FetchContentConfigOptions = {}): Promise<ContentConfig> => {
  const url = `${baseUrl}/content-config`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch content config: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();

    // The API directly returns {content, featureFlags} structure
    return data as ContentConfig;
  } catch (error) {
    console.error('[ContentConfig] Error fetching:', error);
    throw error;
  }
};
